export default function ArticleCtrl(
  $scope,
  $state,
  $window,
  ConfirmService,
  PersonaCollection,
  NewsfeedCollection,
  Utils,
  AlertService,
  articleId,
  pageId,
  fromSearch
) {
  'ngInject';

  const controller = this;
  controller.isLoading = true;
  _loadData();
  controller.users = PersonaCollection.users;

  controller.deleteArticle = deleteArticle;
  controller.moveArticle = moveArticle;
  controller.hasAccessToUser = PersonaCollection.hasAccessToUser;
  controller.editingArticle = null;
  controller.fromSearch = fromSearch;

  async function _loadData() {
    await _setPage();
    await _setArticle();
    controller.isLoading = false;
  }

  async function _setPage() {
    const result = NewsfeedCollection.allChannels.find((c) => String(c.id) === String(pageId));
    if (result) {
      controller.page = await NewsfeedCollection.getChannelDetails(result);
    }
  }

  async function _setArticle() {
    try {
      const article = await NewsfeedCollection.getArticle(controller.page, Utils.getId(articleId), {
        ignoreGlobalErrorHandler: true,
      });
      article.getComments();
      controller.article = article;
    } catch {
      controller.article = null;
    }
  }

  function deleteArticle(articleParam) {
    ConfirmService.ask('Are you sure you want to delete this post?', () => {
      articleParam.remove().then(() => {
        $state.go('newsfeed.view.mynewsfeed');
      });
    }).ignoreCancel();
  }

  async function moveArticle(article) {
    const moved = await NewsfeedCollection.moveArticle(article);
    $state.go('newsfeed.view.page.article', {
      pageId: moved.channel.id,
      articleId: moved.id,
    });
  }

  controller.editArticle = function editArticle(article) {
    controller.editingArticle = article;
  };

  controller.submitArticleEdit = async function submitArticleEdit(content, attachments, sticky) {
    controller.editingArticle.content = content;
    controller.editingArticle.attachments = attachments;
    controller.editingArticle.sticky = sticky;
    await controller.editingArticle.put();

    this.editingArticle = null;
  };

  controller.showErrorToast = function showErrorToast(error) {
    if (error) {
      AlertService.danger(error);
    }
  };

  const unsubscribe = $scope.$on('socket:article:delete', (event, data) => {
    if (data.id === controller.article.id) {
      // TODO: this might be a bit too abrupt
      $state.go('newsfeed.view.mynewsfeed');
    }
  });
  $scope.$on('$destroy', unsubscribe);

  controller.goBack = function goBack() {
    $window.history.back();
  };
}
